module.exports = __webpack_public_path__ + "img/icon_3.fb4d1838.png";